import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["navbar"]

  connect() {
    console.log("Navbar scroll controller connected!")
    this.handleScroll = this.handleScroll.bind(this)
    this.handleScroll() // Initial check
    window.addEventListener('scroll', this.handleScroll)
  }

  disconnect() {
    window.removeEventListener('scroll', this.handleScroll)
  }

  handleScroll() {
    console.log("Scroll detected, scrollY:", window.scrollY)
    const navbar = this.hasNavbarTarget ? this.navbarTarget : this.element
    
    if (window.scrollY > 50) {
      console.log("Adding scrolled class")
      navbar.classList.add('scrolled')
    } else {
      console.log("Removing scrolled class")
      navbar.classList.remove('scrolled')
    }
  }
}
